import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Rl1 } from '@app/models/payroll/rl1.model';
import { BaseForm } from '@app/modules/forms/base.form';
import { ReturnUpdateView } from '../../return-update.view';

@Component({
    templateUrl: './rl-1-update.template.html',
    styleUrl: '../../return-update.style.scss',
})
export class RL1UpdateView extends ReturnUpdateView implements AfterViewInit {
    @ViewChild('rl1Form') rl1Form?: BaseForm;

    get rl1(): Rl1 {
        return this.taxForm as Rl1;
    }

    constructor(route: ActivatedRoute) {
        super(route, 'rl1');
    }

    async save(): Promise<void> {
        if (!this.isFormValid) {
            return;
        }
        this.isLoading = true;
        try {
            await this.rl1.save();
            this.notify.success('payroll.taxForms.RL1.employee.edit.success');

            this.router.navigate(['..'], { relativeTo: this.route });
        } catch (e) {
            this.notify.error(e);
            this.isLoading = false;
        }
    }
}
